// src/pages/ThankYou.jsx

import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Hero from "../component/header";
import Footer from "../component/Footer";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="App">
      <Hero isBlack={true} />

      <div
        className="thankyou-container"
        style={{
          minHeight: "100vh",
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "520px",
            width: "100%",
            background:
              "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
            borderRadius: "20px",
            padding: "60px 30px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
            position: "relative",
          }}
        >
          {/* Success Icon */}
          <div
            style={{
              marginBottom: "30px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CheckCircleOutlined
              style={{
                fontSize: "80px",
                color: "black",
                animation: "scaleIn 0.6s ease-out",
              }}
            />
          </div>

          {/* Decorative Line */}
          <div
            style={{
              width: "60px",
              height: "4px",
              background: "black",
              margin: "0 auto 25px",
              borderRadius: "2px",
            }}
          />

          {/* Main Heading */}
          <h1
            className="font-cinzel"
            style={{
              color: "black",
              fontSize: "clamp(28px, 5vw, 36px)",
              fontWeight: "500",
              margin: "0 0 20px 0",
              lineHeight: "1.2",
            }}
          >
            THANK YOU
          </h1>

          {/* Subtitle */}
          <h3
            style={{
              color: "black",
              fontFamily: "'Outfit', sans-serif",
              fontSize: "clamp(14px, 3vw, 16px)",
              fontWeight: "300",
              lineHeight: "1.6",
              margin: "0 auto 40px",
              maxWidth: "90%",
              opacity: 0.9,
            }}
          >
            Your subscription has been successfully activated. Welcome to a
            nurturing haven where photographers and sculptors can reignite their
            sidelined creative passions
          </h3>

          {/* Back to Home Button */}
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/")}
            className="font-cinzel"
            style={{
              background: "black",
              color: "#fff",
              borderRadius: "12px",
              height: "50px",
              fontSize: "16px",
              fontWeight: "500",
              border: "none",
              padding: "0 40px",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Back to Home
          </Button>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        @keyframes scaleIn {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        @media (max-width: 768px) {
          .thankyou-container .container {
            padding: 50px 25px;
            margin: 20px;
          }
        }

        @media (max-width: 480px) {
          .thankyou-container .container {
            padding: 40px 20px;
            margin: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default ThankYou;
